import { helpers } from 'design-system';

export default function getMaskedMimeType(base64: string): string {
  const actualMime = helpers.extractMime(base64);
  return actualMime.includes('image') ? 'image/png' : 'application/pdf';
}
